import { FormattedMessage as FM } from "react-intl";
import { useSignal } from "@preact/signals-react";
import { useNavigate, useLocation } from "react-router";

import Footer from "pages/Footer";
import CharField from "componentsv2/form/Char";
import PasswordField from "componentsv2/form/Password";
import Button from "componentsv2/button/Button";
import proxy from "api/proxy";
import presikLogo from "assets/img/logo.png";
import { setStorage } from "store/local";
import FullScreenLoading from "components/Tools/FullScreenLoading";

function LoginScreen(props) {
  const loading = useSignal(false);
  const btnDisabled = useSignal(true);
  const username = useSignal("");
  const database = useSignal("");
  const passwd = useSignal("");
  const formMessage = useSignal(null);
  const navigate = useNavigate();
  const location = useLocation();

  const dbField = {
    name: "database",
    label: "company",
    // color: "gray",
    onChange: handleChange,
    mode: "dark",
    uppercase: true,
  };

  const userField = {
    name: "username",
    label: "user",
    mode: "dark",
    onChange: handleChange,
  };

  const passwdField = {
    name: "passwd",
    label: "password",
    mode: "dark",
    onChange: handleChange,
  };

  async function handleSession() {
    loading.value = true;
    const formData = { database, username, passwd };
    const { data: res } = await proxy.fastLogin(formData);

    if (res?.user) {
      res.db = database;
      setStorage("ctxSession", res);
      const { data: userData } = await proxy.search(
        "res.user",
        [["login", "=", username.value]],
        ["employee.id", "employee.rec_name"],
        1,
      );
      if (userData?.[0]?.["employee."]) {
        res.user_employee = userData[0]["employee."];
      }
      navigate(location.state?.from?.pathname || `/dash/${database}`, {
        replace: true,
      });
      props.handleSession(res);
    } else {
      formMessage.value = "login.invalid_user_password";
      loading.value = false;
    }
  }

  async function handleChange(field, value) {
    switch (field) {
      case "database":
        database.value = value.toUpperCase();
        break;
      case "username":
        username.value = value;
        break;
      default:
        break;
    }
    btnDisabled.value = !(database.value && username.value && passwd.value);
    formMessage.value = null;
  }

  return (
    <div className="img-login bg-cover flex w-full mx-auto min-h-full pb-52">
      {loading.value && (
        <FullScreenLoading overlay message="Iniciando sesión..." />
      )}
      <div className="lg:flex mx-auto xl:w-7/12 lg:w-12/12 w-full">
        <div className="px-8 py-0 lg:w-6/12 lg:px-10 xl:px-14 md:w-8/12 sm:w-8/12">
          <img
            src={presikLogo}
            alt="PRESIK LOGO"
            width="180"
            className="lg:mt-12 mt-5 lg:mb-16 mx-auto lg:mx-0"
          />
          <p className="md:mt-3 md:mb-10 mb-2 text-center text-2xl md:text-5xl text-gray-100 font-extrabold">
            Log In
          </p>
          <p className="font-extralight opacity-70 pt-2  md:text-lg text-neutral-100">
            Ingrese sus credenciales para iniciar sesión. Tres intentos de
            contraseña incorrecta bloquearán su usuario.
          </p>
          <form className="grid py-3 gap-y-1" title="login.welcome">
            <CharField {...dbField} data={database} withoutSpaces={true} />
            <CharField {...userField} data={username} withoutSpaces={true} />
            <PasswordField {...passwdField} data={passwd} />
            <div className="my-3" />
            {formMessage.value && (
              <div className="text-red-400 my-3">
                <span>
                  <FM id="login.invalid_user_password" />
                </span>
              </div>
            )}
            <Button
              onClick={handleSession}
              size="w-full"
              color="yellow"
              content="enter"
            />
          </form>
          <Footer />
        </div>
        <div className="w-0 xl:w-1/2 lg:w-1/2 lg:flex hidden">
          <div className="w-1/4 mt-56 mb-0 ml-20">
            <p className="font-roboto text-right font-bold absolute my-24 px-20 sm:px-8 text-6xl/18 text-neutral-100">
              <span className="font-light">
                Where do
                <br /> you dream <br /> of
              </span>
              <span className="text-sky-500"> going</span>?
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;
